// extracted by mini-css-extract-plugin
export var container = "ProspectiveIntro-module--container--a3cf4";
export var link = "ProspectiveIntro-module--link--a82a7";
export var links = "ProspectiveIntro-module--links--6790c";
export var summary = "ProspectiveIntro-module--summary--2765a";